import React from 'react';
import { Badge } from '@/components/ui';
import type { InspectionResult } from '../types/construction-qa.types';

interface Props {
  result?: InspectionResult;
  className?: string;
}

const resultConfig: Record<InspectionResult, { label: string; color: string; icon: string }> = {
  pass: { label: 'ĐẠT', color: 'bg-emerald-500 text-white', icon: 'ri-checkbox-circle-line' },
  fail: { label: 'K.ĐẠT', color: 'bg-rose-500 text-white', icon: 'ri-close-circle-line' },
  pending: { label: 'CHỜ', color: 'bg-slate-400 text-white', icon: 'ri-time-line' },
  na: { label: 'N/A', color: 'bg-slate-100 text-slate-400', icon: 'ri-subtract-line' },
};

export const QaResultBadge: React.FC<Props> = ({ result, className }) => {
  const config = resultConfig[result || 'pending'] || resultConfig.pending;
  
  return (
    <Badge className={`${config.color} border-transparent text-[9px] font-black tracking-wider px-1.5 py-0.5 rounded-sm flex items-center gap-1 ${className}`}>
      <i className={config.icon} />
      {config.label}
    </Badge>
  );
};
